module.exports = __webpack_public_path__ + "img/lg.be4aa4a5.png";